import { render, staticRenderFns } from "./onboarding-features-intro-block.vue?vue&type=template&id=16e52c20&scoped=true&lang=pug"
import script from "./onboarding-features-intro-block.vue?vue&type=script&lang=js"
export * from "./onboarding-features-intro-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e52c20",
  null
  
)

export default component.exports